module.exports = __webpack_public_path__ + "static/media/fastWave.28647ceb.jpg";